import * as React from 'react';
import { Subtract } from 'utility-types';
import WizardContext from './WizardContext';
import { WizardContextProps } from 'interfaces/wizard/wizard';

function withWizardContext<Props extends WizardContextProps>(
  Component: React.ComponentType<Props>
): React.FunctionComponent<Subtract<Props, WizardContextProps>> {
  return (props: Subtract<Props, WizardContextProps>): React.ReactElement => (
    <WizardContext.Consumer>
      {(value: WizardContextProps): React.ReactElement => (
        <Component {...(value as WizardContextProps)} {...(props as Props)} />
      )}
    </WizardContext.Consumer>
  );
}

export default withWizardContext;
